import { Map } from "immutable";
import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();

const GET_ALL_DOCUMENTS_BY_PARENT_ID = "GET_ALL_DOCUMENTS_BY_PARENT_ID";
const SEARCH_DOCUMENT = "SEARCH_DOCUMENT";

export const onGetAllDocumentByParentId = (documentList, isSearch = false) => ({
  type: GET_ALL_DOCUMENTS_BY_PARENT_ID,
  documentList,
  isSearch,
});

export const onSearchDocument = (documentSearch, isSearch = true) => ({
  type: SEARCH_DOCUMENT,
  documentSearch,
  isSearch,
});

export const DocumentRepositoryGetAllDocumentByParentId = (parentId = 0, type = null, isShow = 0, resourceId = null, resourceType=undefined) => {
  return (dispatch) => {
    const params = new URLSearchParams();
    params.append("parentId", parentId);
    if (!!type) {
      params.append("type", type);
      }
      params.append("showUI", isShow);
      resourceId && params.append("resourceId", resourceId);
      resourceType && params.append("resourceType", resourceType);
    return service
      .get(ApiUrl.DocumentRepositoryGetAllDocumentByParentId, params)
      .then((res) => {
        let _dataList = (res && res.content) || [];
        dispatch(onGetAllDocumentByParentId(_dataList));
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
};
export const GetAllDocumentByPlanningId = (planningId, parentId = 0) => {
  return (dispatch) => {
    const params = new URLSearchParams();
    params.append("parentId", parentId);
    params.append("planningId", planningId);
    return service
      .get(ApiUrl.GetAllDocumentByPlanning, params)
      .then((res) => {
        let _dataList = (res && res.content) || [];
        dispatch(onGetAllDocumentByParentId(_dataList));
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const DocumentRepositoryCreateFolder = (data) => {
  return service
    .post(ApiUrl.DocumentRepositoryCreateFolder, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const DocumentRepositoryUploadDocument = (data) => {
  const fromData = new FormData();
  fromData.append("parentId", data.parentId);
    fromData.append("uploadFolderPath", data.uploadFolderPath);
    fromData.append("title", data.title);
    fromData.append("description", data.description);
    fromData.append("docNumber", data.docNumber);
    fromData.append("publishDate", data.publishDate);
    fromData.append("showUi", data.showUi);
    data.categoryId && fromData.append("categoryId", data.categoryId);
    data.governmentId && fromData.append("governmentId", data.governmentId);
    data.resourceId && fromData.append("resourceId", data.resourceId);
    data.resourceType && fromData.append("resourceType", data.resourceType);
    fromData.append("content", data.content);
  data.uploadFile &&
    data.uploadFile.forEach(
      (item) => item && fromData.append("uploadFile", item)
    );
  return service
    .post(ApiUrl.DocumentRepositoryUploadDocument, fromData)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const DocumentRepositoryDownloadDocument = (listItemPaths, callback) => {
  if (!listItemPaths) return;
  return service.postBinary(ApiUrl.DownloadDocument, listItemPaths, null, callback).then((res) => { return res }).catch(err => { throw err });
};

export const DocumentRepositoryRenameDocument = (data) => {
  const params = new URLSearchParams();
  params.append("documentId", data.documentId);
    params.append("newFileName", data.newFileName);
    params.append("title", data.title);
    params.append("description", data.description);
    params.append("docNumber", data.docNumber);
    params.append("publishDate", data.publishDate);
    params.append("name", data.name);
    params.append("content", data.content);
    data.categoryId && params.append("categoryId", data.categoryId);
    data.governmentId && params.append("governmentId", data.governmentId);
  return service
    .post(ApiUrl.DocumentRepositoryRenameDocument, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const DocumentRepositoryDeleteDocument = (data) => {
  return service
    .post(ApiUrl.DocumentRepositoryDeleteDocument, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const DocumentRepositoryMoveDocument = (data) => {
  return service
    .post(ApiUrl.DocumentRepositoryMoveDocument, data)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const DocumentRepositorySearchDocument = (data) => {
  return (dispatch) => {
    const params = new URLSearchParams();
    params.append("parentId", data.parentId);
    params.append("fileName", data.fileName);
    return service
      .get(ApiUrl.DocumentRepositorySearchDocument, params)
      .then((res) => {
        let _dataList = (res && res.content) || [];
        dispatch(onSearchDocument(_dataList));
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const DocumentRepositoryGetParentDocumentById = (id) => {
  const params = new URLSearchParams();
  params.append("id", id);
  return service
    .get(ApiUrl.DocumentRepositoryGetParentDocumentById, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const initialState = Map({
  documentList: [],
  documentSearch: [],
  isSearch: false,
}).toJS();

export default function DocumentRepositoryReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_ALL_DOCUMENTS_BY_PARENT_ID:
      return {
        ...state,
        documentList: action.documentList,
        isSearch: false,
      };
    case SEARCH_DOCUMENT:
      return {
        ...state,
        documentSearch: action.documentSearch,
        isSearch: true,
      };
    default:
      return { ...state };
  }
}
